import { defineMessages } from 'react-intl';

export default defineMessages({
    fees: {
        id: '_.draw_down.choose_amount.fees',
        defaultMessage: 'Fees'
    },
    always: {
        id: '_.draw_down.choose_amount.always',
        defaultMessage: 'always'
    }
});
